export default {
  lookups_request (state, { type, data }) {
    state[type] = data
  },
  states_request (state, { data }) {
    state.states = data
  },
  cities_request (state, { data }) {
    state.cities = data
  },
  postcodes_request (state, { data }) {
    state.postcodes = data
  },
}
